export default __webpack_public_path__ + "static/media/Domine-Regular.18d21531.ttf";